import { useMemo, useReducer } from 'react';
import {
  initialTableQueryState,
  tableQueryReducer,
} from '../reducers/tableQueryReducer';
import type { UseDataTableStateOptions } from '../types';

export const useDataTableState = ({
  initialState,
}: UseDataTableStateOptions = {}) => {
  const mergedInitialState = useMemo(
    () => ({ ...initialTableQueryState, ...initialState }),
    [initialState]
  );
  const [state, dispatch] = useReducer(tableQueryReducer, mergedInitialState);

  return { state, dispatch };
};
